export default __webpack_public_path__ + "static/media/bnc-logo-v2.fbc32900.svg";